import { HttpBackend } from '@angular/common/http';

import { TranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';

import { DEFAULT_LANGUAGE_CODE } from '../services/language-state.service';

const TRANSLATION_FILES = [
  'analytics',
  'auth',
  'audits',
  'categories',
  'common',
  'enclaves',
  'layout',
  'news',
  'routes',
  'users',
] as const;

function createTranslateLoader(httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(
    httpBackend,
    TRANSLATION_FILES.map((file) => ({
      prefix: '/i18n/',
      suffix: `/${file}.json`,
    })),
  );
}

export function provideI18n() {
  return provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: createTranslateLoader,
      deps: [HttpBackend],
    },
    fallbackLang: DEFAULT_LANGUAGE_CODE,
    lang: DEFAULT_LANGUAGE_CODE,
  });
}
